import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom'
import WrappedPage from './components/WrappedPage';
import PrivateRoute from './components/PrivateRoute';
import Landing from './pages/Landing';
import Notifications from './pages/Notifications';
import Users from './pages/Users';
import Dashboard from './pages/Dashboard';
import PasswordReset from './pages/PasswordReset';
import Invitations from './pages/Invitations';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import ShareInvitations from './pages/SharedInvitations';

import ListsDetails from './pages/Lists/Details';
import ListsShare from './pages/Lists/Share';
import ListsNew from './pages/Lists/New';
import ListsEdit from './pages/Lists/Edit';

import GroupsDetails from './pages/Groups/Details';
import GroupsNew from './pages/Groups/New';
import GroupsShare from './pages/Groups/Share';

import EventsNew from './pages/Events/NewEvent';

import AccountLayout from './pages/Layouts/AccountLayout';
import Account from './pages/Account/Account';
import Profile from './pages/Account/Profile';
import Settings from './pages/Account/Settings';

import NotFound from './pages/NotFound';

const Router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Public routes */}
      <Route path='login' element={<Login />} />
      <Route path='invitations/:invitation' element={<Invitations />} />
      <Route path='share/invitations/:invitation' element={<ShareInvitations />} />
      <Route path='pw-reset/:token' element={<PasswordReset />} />
      <Route element={<PrivateRoute />}>
        <Route element={<WrappedPage />}>
          {/* Private routes (authenticated with user context) */}
          <Route index element={<Landing />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="account" element={<AccountLayout />}>
            <Route index element={<Account />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="change-password" element={<ChangePassword />} />
          <Route path='lists'>
            <Route path="new" element={<ListsNew />} />
            <Route path="share/:id" element={<ListsShare />} />
            <Route path="details/:id" element={<ListsDetails />} />
            <Route path="edit/:id" element={<ListsEdit />} />
          </Route>
          <Route path='groups'>
            <Route path="new" element={<GroupsNew />} />
            <Route path="share/:id" element={<GroupsShare />} />
            <Route path="details/:id" element={<GroupsDetails />} />
          </Route>
          <Route path='events'>
            <Route path="new" element={<EventsNew />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </>
  )
)

export default Router;